/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ThemesWithCustomQuestionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ThemesWithCustomQuestionsQuery = { themes: Array<{ id: number, name: string, color: string, icon: string, lastUsedAt?: string | undefined, nextUsedAt?: string | undefined, questions: Array<{ id: number, name: string }> }> };


export const ThemesWithCustomQuestionsDocument = gql`
    query ThemesWithCustomQuestions {
  themes(limit: 0, withCustomQuestionsOnly: true) {
    id
    name
    color
    icon
    lastUsedAt
    nextUsedAt
    questions(isAvailableForCustom: true) {
      id
      name
    }
  }
}
    `;

/**
 * __useThemesWithCustomQuestionsQuery__
 *
 * To run a query within a React component, call `useThemesWithCustomQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemesWithCustomQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemesWithCustomQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useThemesWithCustomQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<ThemesWithCustomQuestionsQuery, ThemesWithCustomQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThemesWithCustomQuestionsQuery, ThemesWithCustomQuestionsQueryVariables>(ThemesWithCustomQuestionsDocument, options);
      }
export function useThemesWithCustomQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThemesWithCustomQuestionsQuery, ThemesWithCustomQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThemesWithCustomQuestionsQuery, ThemesWithCustomQuestionsQueryVariables>(ThemesWithCustomQuestionsDocument, options);
        }
export type ThemesWithCustomQuestionsQueryHookResult = ReturnType<typeof useThemesWithCustomQuestionsQuery>;
export type ThemesWithCustomQuestionsLazyQueryHookResult = ReturnType<typeof useThemesWithCustomQuestionsLazyQuery>;
export type ThemesWithCustomQuestionsQueryResult = Apollo.QueryResult<ThemesWithCustomQuestionsQuery, ThemesWithCustomQuestionsQueryVariables>;